/**
 * State de navigation react-router a passer a un lien vers /inscription/preteur
 * pour ouvrir directement le formulaire d'inscription investisseur, avec le
 * statut juridique "Personne physique" preselectionne.
 *
 * Register.jsx affiche par defaut l'etape 1 (investir / obtenir un financement)
 * puis l'etape 2 (particulier / entreprise). Des que `state.form` est present,
 * il passe directement a l'etape 3 — le formulaire — en conservant son
 * `formType` par defaut, qui est justement "naturalPersonRegisterForm".
 * L'objet peut donc etre vide : il ne sert qu'a declencher ce raccourci.
 *
 * Voir l'effet sur `location.state?.form` dans components/Register.jsx.
 */
export const REGISTER_DIRECT_STATE = { form: {} };
